if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        const variantIdInput = this.variantIdInput;
        if (variantIdInput) variantIdInput.disabled = false;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.submitButton) return;

        this.upsellVariantId = this.dataset.upsellVariantId;
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map(section => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        try {
          // Initialize cart session if count is 0 and upsell exists
          const cartResponse = await fetch(`${window.routes.cart_url}.js`);
          const cartState = await cartResponse.json();

          if (cartState.item_count === 0 && this.upsellVariantId) {
            await fetch(`${window.routes.cart_add_url}`, this.getUpsellProductConfig());
          }

          const response = await fetch(`${window.routes.cart_add_url}`, config);
          const responseData = await response.json();

          if (responseData.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: responseData.errors || responseData.description,
              message: responseData.message
            });

            this.handleErrorMessage(responseData.description || responseData.message);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            this.error = true;
            return;
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: responseData
            });
          }

          this.error = false;

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(responseData);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(responseData);
          }
        } catch (error) {
          console.error('Add to cart error:', error);
          this.handleErrorMessage(error.message);
          this.error = true;
        } finally {
          this.submitButton.classList.remove('loading');

          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }

          // Always re-enable the button so the user can try again if the error is transient
          const buttons = document.querySelectorAll(`button[name="add"][form="${this.form.id}"], button[name="add"]`);
          buttons.forEach(button => button.removeAttribute('aria-disabled'));

          this.querySelector('.loading__spinner').classList.add('hidden');
        }
      }
      getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append('id', this.upsellVariantId);
        upsellFormData.append('quantity', 1);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = upsellFormData;

        return config;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        const buttons = document.querySelectorAll(`button[name="add"][form="${this.form.id}"], button[name="add"]`);
        buttons.forEach(button => {
          const buttonText = button.querySelector('.atc-text') || button.querySelector('span') || button;
          const buttonPrice = button.querySelector('.atc-price');
          
          if (disable) {
            button.setAttribute('disabled', 'disabled');
            if (text) buttonText.textContent = text;
            if (buttonPrice) buttonPrice.style.display = 'none';
          } else {
            button.removeAttribute('disabled');
            buttonText.textContent = button.dataset.addToCartText || window.variantStrings.addToCart;
            if (buttonPrice) buttonPrice.style.cssText = '';
          }
        });
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}